import React from 'react'
import { Button } from 'antd'
import { Plus } from 'lucide-react'
import { useFFEStore } from '../../store/ffeStore'
import { useShallow } from 'zustand/react/shallow'
import { AddFromUrlButton } from './AddFromUrlButton'
import { AddFromQuoteButton } from './AddFromQuoteButton'

interface Props {
  groupId?: string
  depth?: number
}

export const AddLineItemButton: React.FC<Props> = ({ groupId, depth }) => {
  const addLineItem = useFFEStore((state) => state.addLineItem)
  const addGroup = useFFEStore((state) => state.addGroup)
  const defaultMargin = useFFEStore(
    (state) => state.document.settings.defaultMargin
  )
  const hasLineItemsOrGroups = useFFEStore(
    useShallow(
      (state) =>
        state.document.lineItems.length > 0 || state.document.groups.length > 0
    )
  )

  const handleAddItem = () => {
    addLineItem({
      name: '',
      description: '',
      quantity: 1,
      margin: defaultMargin,
      costPrice: 0,
      sellPrice: 0,
      status: 'specified',
      groupId
    })
  }

  return (
    <div className="flex flex-row gap-2">
      {/* <Button type="default" icon={<Plus className="h-4 w-4" />}>
        Item from library
      </Button> */}
      <Button type={hasLineItemsOrGroups ? 'default' : 'primary'} icon={<Plus className="h-4 w-4" />} onClick={handleAddItem}>
        New item
      </Button>
      <AddFromUrlButton 
        groupId={groupId} 
      />
      <AddFromQuoteButton 
        groupId={groupId} 
      />
      {
        !groupId && (
          <Button type="default" icon={<Plus className="h-4 w-4" />} onClick={() => addGroup('New Group')}>
            New group
          </Button>
        )
      }
      {
        groupId && depth !== undefined && depth < 3 && (
          <Button type="default" icon={<Plus className="h-4 w-4" />} onClick={() => addGroup('New Group', groupId)}>
            New subgroup
          </Button>
        )
      }
    </div>
  )
}
